import * as React from "react";
import { StyleSheet } from "react-native";
import Colors from "../../constants/Colors";
import { Text, View } from "../Themed";

type Props = {
  number: number;
  text: string;
  style?: any;
};

export default function StatsBlock(props: Props) {
  const { number = 0, text = "", style } = props;

  return (
    <View style={[styles.statBlock, style]}>
      <Text
        size={24}
        lineHeight={36}
        weight={"Bold"}
        lightColor={Colors.nuetral_grey_700}
      >
        {number}
      </Text>
      <Text size={16} weight={"SemiBold"} lightColor={Colors.nuetral_grey_600}>
        {text}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  statBlock: {
    alignItems: "center",
    backgroundColor: "transparent",
  },
});
